import ApiConstant from "../../constants/api.constants";
import api from "../api";

const getUserSwipeMachineMapping = async () => {
  try {
    const result: any = await api.get(ApiConstant.getUserSwipeMachineMapping);
    return {
      data: result.data ?? [],
    };
  } catch (error) {
    console.error("error reading user swipe machine mapping.", error);
    return {
      data: [],
      totalCount: 0
    };
  }
};

const addUserSwipeMachineMapping = async (data: any) => {
  try {
    const result: any = await api.post(ApiConstant.addUserSwipeMachineMapping, data);
      return result.data;      
  } catch {
    console.error("error in addUserSwipeMachineMapping");
    return [];
  }
};

const updateUserSwipeMachineMapping = async (data: any) => {
  try {
    const result: any = await api.put(ApiConstant.updateUserSwipeMachineMapping,data);
    return result.data;
  } catch (error) {
    console.error("error updating user swipe machine mapping", error);
    return false;
  }
};

const getSwipeMachines = async () => {
  try {
    const result: any = await api.get(ApiConstant.getSwipeMachines);
    return {
      data: result?.data ?? []
    };
  } catch (error) {
    console.error("error reading swipe machine data.", error);
    return { data: [] };
  }
};

const userSwipeMachineService = {
  getUserSwipeMachineMapping,
  addUserSwipeMachineMapping,
  updateUserSwipeMachineMapping,
  getSwipeMachines
};

export default userSwipeMachineService;
